import React from 'react'
import { formatNumber, formatCurrency } from '../../lib/format-number'

const TotalRow = ({ revenueTotals, reportType }) => {
    let r = revenueTotals && revenueTotals.length > 0 && revenueTotals[0]
    if (r) {
        if (reportType == 'summary') {
            return (
                <tr key={r.currency} style={{ fontSize: 16, borderTop: '2px solid #d8d8d8' }}>
                    <td className="revenue-list revenue-list--overview" colSpan="2">
                        <span>TOTAL (filters applied)</span>
                    </td>
                    <td className="revenue-list revenue-list--revenue">{formatNumber(r.impressions)}</td>
                    <td className="revenue-list revenue-list--revenue">{formatCurrency(r.revenueGross, r.currency)}</td>
                    <td className="revenue-list revenue-list--revenue">{formatCurrency(r.revenueNet, r.currency)}</td>
                </tr>
            )
        } else {
            return (
                <tr key={r.currency} style={{ fontSize: 16, borderTop: '2px solid #d8d8d8' }}>
                    <td className="revenue-list revenue-list--overview" colSpan="4">
                        <span>TOTAL (filters applied)</span>
                    </td>
                    <td className="revenue-list revenue-list--revenue">{formatNumber(r.impressions)}</td>
                    <td className="revenue-list revenue-list--revenue">{formatNumber(r.clicks)}</td>
                    <td className="revenue-list revenue-list--revenue">{formatCurrency(r.revenueGross, r.currency)}</td>
                    <td className="revenue-list revenue-list--revenue">{formatCurrency(r.revenueNet, r.currency)}</td>
                </tr>
            )
        }
    }
    return <div />
}

export default TotalRow
